import 'lity'

export function lityPopup() {
	$('body').on('click', '.lity img', function () {
		$(this).hasClass('zoom')
			? $(this).removeClass('zoom')
			: $(this).addClass('zoom');
	})
}
/**
 * Sets up the scrolled class
 */
export function setup_scrolling()
{
	$(window).on('scroll', function() {
		//Add the 'scrolled' class
		let scroll = $(this).scrollTop();
		let body = $('body');
		if(scroll > 100)
		{
			body.addClass('scrolled');
		}
		else
		{
			body.removeClass('scrolled');
		}
	});
}

/**
 * Sets up a scroll to top on any back to top classes
 */
export function setup_back_to_top()
{
	$('.back-to-top').click(function (e){
		e.preventDefault();
		$('html,body').animate({
			scrollTop: 0,
		}, 'slow');
	});
}

export function copy_link()
{
	$('.copy-link').on('click', function ()
	{
		let link = $(this).attr('data-link');
		let $temp = $('<input>');
		
		$('body').append($temp);
		$temp.val(link).select();
		document.execCommand('copy');

		$temp.remove();
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/page.js